// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__DfYjk","content":"Tab_content__k2yS7","secondary":"Tab_secondary__yJRc0","active":"Tab_active__-gFxf"};